import React, { useContext, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

import UiKit from 'components/UiKit';
import { AuthContext } from 'context/AuthContext';
import { ReactComponent as LogoutIcon } from 'images/icons/logout.svg';

export default function Header({ data }) {
  const { push } = useHistory();
  const { logout } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { avatarPicUrl = '' } = data;
  // Initials are rendered locally; never send the shopper's name to a third party.
  const initials = useMemo(() => {
    const { firstName, lastName } = data;
    // String() guards against null names from the API.
    const first = String(firstName || '').charAt(0);
    const last = String(lastName || '').charAt(0);
    return `${first}${last}`.toUpperCase();
  }, [data]);

  const onToggle = () => setDropdownOpen((isOpen) => !isOpen);

  const onLogout = () => logout(() => push('/login'));

  return (
    <>
      <ul className="nav navbar-nav ml-auto ">
        <li className="nav-item mobile-link">
          <div
            className="nav-link"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div className="text-right">{data.firstName}</div>
            <div className="text-right email">({data.email})</div>
          </div>
        </li>
      </ul>
      <Dropdown className="nav-item" isOpen={dropdownOpen} toggle={onToggle}>
        <DropdownToggle
          className="nav-link mr-0 border-0"
          aria-label="Initials Picture"
        >
          {avatarPicUrl ? (
            <img className="img-avatar" src={avatarPicUrl} alt="" />
          ) : (
            <span className="img-avatar img-avatar-initials" aria-hidden="true">
              {initials}
            </span>
          )}
        </DropdownToggle>
        <DropdownMenu
          onClick={onToggle}
          right
          style={{ right: 'auto', height: 'auto' }}
        >
          <Link className="dropdown-item" role="menuitem" to="/account/orders">
            My Orders
          </Link>
          <UiKit.Button
            variant="ghost"
            size="lg"
            className="dropdown-item logout"
            role="menuitem"
            onClick={onLogout}
          >
            Logout
            <LogoutIcon />
          </UiKit.Button>
        </DropdownMenu>
      </Dropdown>
    </>
  );
}
